import styled from 'styled-components';

const BusinessSummarySectionEditStyled = styled.section`
    .BusinessSummary-textarea {
        border-radius: 8px;
    }
`;

export { BusinessSummarySectionEditStyled };
